import React, { useState } from 'react';

const navItems = ['Hey', 'Work', 'Skills', 'Chat'];

export default function Header({ onNavClick }) {
  const [selectedItem, setSelectedItem] = useState('Hey');

  const handleClick = (e, item) => {
    e.preventDefault();
    setSelectedItem(item);
    onNavClick(item);
  };

  return (
    <header className="w-full flex justify-center pt-8 z-10">
      <nav className="bg-black bg-opacity-80 rounded-full px-6 py-3 shadow-lg flex lg:space-x-10 md:space-x-10">
        {navItems.map((item) => (
          <button
            type="button"
            key={item}
            className={`nav-item text-white text-lg font-medium hover:text-yellow-300 transition-colors duration-300 border-0 cursor-pointer ${
              selectedItem === item ? 'bg-transparent' : ''
            }`}
            style={{
              backgroundColor: selectedItem === item ? 'rgba(100,100,100,0.2)' : 'rgba(0,0,0,0)',
              borderRadius: '9999px',
              padding: '8px 16px',
              transition: 'background-color 0.3s ease',
            }}
            onClick={e => handleClick(e, item)}
          >
            {item}
          </button>
        ))}
      </nav>
    </header>
  );
} 